<template>
    <Audit v-if="openModal" @close="openModal = false" :open="openModal" :activity_logs="activity_logs" />
    <TransitionRoot appear as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen" ref="createService">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4 bg-amaze-coral sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white font-bold" v-if="form.id">
                                                Update Service `{{ form.name }}`
                                            </DialogTitle>
                                            <DialogTitle class="text-lg text-white font-bold" v-else>
                                                Create Service
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-amaze-coral rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-white">
                                                Get started by filling in the information below to create a new
                                                service.
                                            </p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true"/>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="pt-6 pb-5 grid grid-cols-12 grid-rows-12 gap-3 items-center">
                                                <h2 class="col-span-10 text-lg text-bold">Service Information</h2>
                                                <button type="button" @click="openModal = true"
                                                    class="col-span-2 items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                                                    Show Changelog
                                                </button>
                                                    <div class="col-span-2">
                                                        <label for="service_name"
                                                               class="block text-sm text-gray-900 required">
                                                            Item
                                                        </label>
                                                        <div class="mt-1">
                                                            <input type="text" id="service_name" v-model="form.name"
                                                                   class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                                   :class="{'border-red-500': form.errors.name}"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div class="col-span-2">
                                                        <label for="service_starts_at"
                                                               class="block text-sm text-gray-900 required">
                                                            Start Date
                                                        </label>
                                                        <div class="mt-1">
                                                            <input type="date" id="service_starts_at"
                                                                   v-model="form.starts_at"
                                                                   class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                                   :class="{'border-red-500': form.errors.starts_at}"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div class="col-span-2">
                                                        <label for="service_starts_at"
                                                               class="block text-sm text-gray-900 required">
                                                            End Date
                                                        </label>
                                                        <div class="mt-1">
                                                            <input type="date" id="service_ends_at"
                                                                   v-model="form.ends_at"
                                                                   class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                                   :class="{'border-red-500': form.errors.ends_at}"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div class="col-span-2">
                                                        <label for="folder-name"
                                                               class="block text-sm text-gray-900 required">
                                                            Country
                                                        </label>
                                                        <select id="country_id" v-model="form.country_id"
                                                                :class="{'border-red-500': form.errors.country_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select a country'"></option>
                                                            <option v-for="country in countries" :value="country.id">
                                                                {{ country.name }}
                                                            </option>
                                                        </select>
                                                    </div>


                                                    <div class="col-span-2">
                                                        <label for="folder-name"
                                                               class="block text-sm text-gray-900">
                                                            Service Type
                                                        </label>
                                                        <select id="service_type_id" v-model="form.service_type_id"
                                                                :class="{'border-red-500': form.errors.service_type_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select a service type'"></option>
                                                            <option v-for="service_type in service_types"
                                                                    :value="service_type.id">{{ service_type.name }}
                                                            </option>
                                                        </select>
                                                    </div>

                                                    <div class="col-span-2">
                                                        <Combobox as="div" v-model="selectedSupplier" nullable>
                                                            <span class="block text-sm text-gray-900 flex items-center">
                                                                    <span>Supplier</span>
                                                                    <a class="text-xs text-light-pitch-purple mx-3"
                                                                       target="_blank"
                                                                       :href="route('frontend.organisations.create', ['supplier'])">Create New Supplier</a>
                                                                    <RefreshIcon @click="refreshSuppliers()"
                                                                                 class="w-4 h-4 text-light-pitch-purple"></RefreshIcon>
                                                                </span>
                                                            <div class="relative mt-1">
                                                                <ComboboxInput
                                                                    class="w-full mt-1 rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-light-pitch-purple focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                                                    @change="query = $event.target.value"
                                                                    :display-value="(supplier) => supplier?.name ?? 'TBC'"/>
                                                                <ComboboxButton
                                                                    class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                                    <SelectorIcon class="h-5 w-5 text-gray-400"
                                                                                  aria-hidden="true"/>
                                                                </ComboboxButton>

                                                                <ComboboxOptions v-if="filteredSuppliers.length > 0"
                                                                                 class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                                    <ComboboxOption

                                                                        :key="'tbc'" :value="''"
                                                                        as="template" v-slot="{ active, selected }">
                                                                        <li :class="['relative cursor-pointer select-none py-2 pl-4 pr-4', active ? 'bg-amaze-coral text-white' : 'text-gray-900']">
                                                                    <span
                                                                        :class="['block truncate', selected && 'font-semibold']">
                                                                      TBC
                                                                    </span>
                                                                        </li>
                                                                    </ComboboxOption>
                                                                    <ComboboxOption
                                                                        v-for="supplier in filteredSuppliers"
                                                                        :key="supplier.id" :value="supplier"
                                                                        as="template" v-slot="{ active, selected }">
                                                                        <li :class="['relative cursor-pointer select-none py-2 pl-4 pr-4', active ? 'bg-amaze-coral text-white' : 'text-gray-900']">
                                                                    <span
                                                                        :class="['block truncate', selected && 'font-semibold']">
                                                                      {{ supplier.name }}
                                                                    </span>
                                                                        </li>
                                                                    </ComboboxOption>
                                                                </ComboboxOptions>
                                                            </div>
                                                        </Combobox>
                                                    </div>
                                                    <div class="col-span-6">
                                                        <label
                                                            class="block text-sm font-medium text-gray-700">Description</label>
                                                        <div class="mt-1">
                                                            <editor  ref="description"
                                                                          v-model="form.description"
                                                                          :class="{'border-red-500': form.errors.description}"
                                                                          class="min-h-[150px] mt-1 block w-full bg-white border border-gray-300 shadow-sm py-2 px-3"
                                                                          ></editor>
                                                        </div>
                                                    </div>
                                                <div class="col-span-6">
                                                    <label
                                                        class="block text-sm font-medium text-gray-700">Financial Notes</label>
                                                    <div class="mt-1">
                                                        <editor ref="financial_notes"
                                                                      v-model="form.financial_notes"
                                                                      :class="{'border-red-500': form.errors.financial_notes}"
                                                                      class="min-h-[150px] mt-1 block w-full bg-white border border-gray-300 shadow-sm py-2 px-3"
                                                                      ></editor>
                                                    </div>
                                                </div>

                                                <h2 class="col-span-12 text-lg text-bold">Buy Information</h2>

                                                <div class="col-span-2">
                                                    <label for="buy_price"
                                                           class="block text-sm text-gray-900 required">
                                                        Price
                                                    </label>
                                                    <div class="relative mt-1">
                                                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                            <span class="text-gray-500 sm:text-sm">{{ quote.buy_currency.symbol }}</span>
                                                        </div>
                                                        <input type="text" id="buy_price" v-model="form.buy_price"
                                                               class="pl-7 block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.buy_price}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-2">
                                                    <label for="buy_costing_type"
                                                           class="block text-sm text-gray-900 required">
                                                        Costing Type
                                                    </label>
                                                    <select id="buy_costing_type" v-model="form.buy_costing_type"
                                                            :class="{'border-red-500': form.errors.buy_costing_type}"
                                                            class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                        <option value selected
                                                                v-html="'Select a costing type'"></option>
                                                        <option v-for="(costing_type, index) in costing_types"
                                                                :value="costing_type" v-html="costing_type"></option>
                                                    </select>
                                                </div>

                                                <div class="col-span-2">
                                                    <label for="buy_vat_rate"
                                                           class="block text-sm text-gray-900 required">
                                                        VAT Percentage
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="buy_vat_rate"
                                                                v-model="form.buy_vat_percentage"
                                                                :class="{'border-red-500': form.errors.buy_vat_percentage}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select a VAT percentage'"></option>
                                                            <option v-for="vat_rate in vat_rates" :value="vat_rate.percentage">
                                                                {{ vat_rate.label }}
                                                            </option>

                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-1">
                                                    <label for="buy_unit"
                                                           class="block text-sm text-gray-900 required flex items-center">
                                                        <span>Qty.</span>
                                                        <Popper :hover="true" class="cursor-pointer" placement="top" content="The quantity purchased per item.">
                                                            <InformationCircleIcon class="h-5 w-5 text-gray-400"
                                                                                   aria-hidden="true"/>
                                                        </Popper>
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="number" id="buy_unit" v-model="form.buy_unit"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.buy_unit}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-1">
                                                    <label for="buy_no"
                                                           class="block text-sm text-gray-900 required flex items-center">
                                                        <span>No.</span>
                                                        <Popper :hover="true" class="cursor-pointer" placement="top" content="The number of items required.">
                                                            <InformationCircleIcon class="h-5 w-5 text-gray-400"
                                                                                   aria-hidden="true"/>
                                                        </Popper>
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="number" id="buy_no" v-model="form.buy_no"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.buy_no}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-1">

                                                </div>

                                                <div class="col-span-1">
                                                    <label for="buy_net_total"
                                                           class="block text-sm text-gray-900">
                                                        Net Total
                                                    </label>
                                                    <div class="relative mt-1">
                                                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                            <span class="text-gray-500 sm:text-sm">{{ quote.buy_currency.symbol }}</span>
                                                        </div>
                                                        <input disabled type="text" id="buy_net_total"
                                                               v-model="form.buy_net_total"
                                                               class="pl-7 bg-gray-100 cursor-not-allowed block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.buy_net_total}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-1">
                                                    <label for="buy_gross_total"
                                                           class="block text-sm text-gray-900">
                                                        Gross Total
                                                    </label>
                                                    <div class="relative mt-1">
                                                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                            <span class="text-gray-500 sm:text-sm">{{ quote.buy_currency.symbol }}</span>
                                                        </div>
                                                        <input disabled type="text" id="buy_gross_total"
                                                               v-model="form.buy_gross_total"
                                                               class="pl-7 bg-gray-100 cursor-not-allowed block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.buy_gross_total}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-1">
                                                </div>


                                                <h2 class="col-span-12 text-lg text-bold">Sell Information


                                                </h2>

                                                <div class="col-span-2">
                                                    <label for="sell_price"
                                                           class="block text-sm text-gray-900 required">
                                                        Price
                                                    </label>
                                                    <div class="relative mt-1">
                                                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                            <span class="text-gray-500 sm:text-sm">{{ project.bank_account.currency.symbol }}</span>
                                                        </div>
                                                        <input type="text" id="sell_price" v-model="form.sell_price"
                                                               class="pl-7 block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.sell_price}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-2"
                                                     >
                                                    <label for="sell_costing_type"
                                                           class="block text-sm text-gray-900 required">
                                                        Costing Type
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="sell_costing_type" v-model="form.sell_costing_type"
                                                                :class="{'border-red-500': form.errors.sell_costing_type}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select a costing type'"></option>
                                                            <option v-for="(costing_type, index) in costing_types"
                                                                    :value="costing_type"
                                                                    v-html="costing_type"></option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-2"
                                                     >
                                                    <label for="sell_vat_rate"
                                                           class="block text-sm text-gray-900 required">
                                                        VAT Percentage
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="sell_vat_rate"
                                                                v-model="form.sell_vat_percentage"
                                                                :class="{'border-red-500': form.errors.sell_vat_percentage}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select a VAT percentage'"></option>
                                                            <option v-for="vat_rate in vat_rates" :value="vat_rate.percentage">
                                                                {{ vat_rate.label }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-1"
                                                     >
                                                    <label for="sell_unit"
                                                           class="block text-sm text-gray-900 required flex items-center">
                                                        <span>Qty.</span>
                                                        <Popper :hover="true" class="cursor-pointer" placement="top" content="The quantity purchased per item.">
                                                            <InformationCircleIcon class="h-5 w-5 text-gray-400"
                                                                                   aria-hidden="true"/>
                                                        </Popper>
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="number" id="sell_unit" v-model="form.sell_unit"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.sell_unit}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-1"
                                                    >
                                                    <label for="sell_no"
                                                           class="block text-sm text-gray-900 required flex items-center">
                                                        <span>No.</span>
                                                        <Popper :hover="true" class="cursor-pointer" placement="top" content="The number of items required.">
                                                            <InformationCircleIcon class="h-5 w-5 text-gray-400"
                                                                                   aria-hidden="true"/>
                                                        </Popper>
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="number" id="sell_no" v-model="form.sell_no"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.sell_no}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-1">
                                                </div>

                                                <div class="col-span-1">
                                                    <label for="sell_net_total"
                                                           class="block text-sm text-gray-900">
                                                        Net Total
                                                    </label>
                                                    <div class="relative mt-1">
                                                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                            <span class="text-gray-500 sm:text-sm">{{ project.bank_account.currency.symbol }}</span>
                                                        </div>
                                                        <input disabled type="text" id="sell_net_total"
                                                               v-model="form.sell_net_total"
                                                               class="pl-7 bg-gray-100 cursor-not-allowed block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.sell_net_total}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-1">
                                                    <label for="sell_gross_total"
                                                           class="block text-sm text-gray-900">
                                                        Gross Total
                                                    </label>
                                                    <div class="relative mt-1">
                                                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                            <span class="text-gray-500 sm:text-sm">{{ project.bank_account.currency.symbol }}</span>
                                                        </div>
                                                        <input disabled type="text" id="sell_gross_total"
                                                               v-model="form.sell_gross_total"
                                                               class="pl-7 bg-gray-100 cursor-not-allowed block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.sell_gross_total}"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="col-span-1">
                                                </div>

                                                <h2 class="col-span-12 text-lg text-bold">Commission</h2>

                                                <div class="col-span-2">
                                                    <label for="commission_type"
                                                           class="block text-sm text-gray-900">
                                                        Percentage or Fixed Amount
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="commission_type" v-model="form.commission_type"
                                                                :class="{'border-red-500': form.errors.commission_type}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select an option'"></option>
                                                            <option v-for="(amount_type,index) in amount_types"
                                                                    v-html="amount_type" :value="amount_type"></option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-2">
                                                    <label for="folder-name"
                                                           class="block text-sm text-gray-900">
                                                        Costing Type
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="commission_costing_type" :disabled="form.commission_type === 'Fixed'"
                                                                v-model="form.commission_costing_type"
                                                                :class="{'border-red-500': form.errors.commission_costing_type}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select a costing type'"></option>
                                                            <option v-for="(costing_type, index) in costing_types"
                                                                    :value="costing_type"
                                                                    v-html="costing_type"></option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-2">
                                                    <label for="commission_amount"
                                                           class="block text-sm text-gray-900">
                                                        Amount
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="commission_amount"
                                                               v-model="form.commission_amount"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.commission_amount}"
                                                        />
                                                    </div>
                                                </div>


                                                <div class="col-span-3">
                                                    <div class="relative flex items-start mt-5 items-center">
                                                        <div class="flex items-center h-5">
                                                            <button type="button"
                                                                    @click="form.is_including_commission_vat = !form.is_including_commission_vat"
                                                                    :class="{'bg-amaze-coral': form.is_including_commission_vat, 'bg-gray-200': !form.is_including_commission_vat }"
                                                                    class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
                                                                    role="switch" aria-checked="false">
                                                                <span class="sr-only">Is Percentage</span>
                                                                <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
                                                                <span aria-hidden="true"
                                                                      :class="[form.is_including_commission_vat ? 'translate-x-5': 'translate-x-0' ]"
                                                                      class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                                            </button>
                                                        </div>
                                                        <div class="ml-3 text-sm">
                                                            <label for="candidates" class="font-medium text-gray-700">Amount/Percentage includes <br>Commission VAT @ {{ number_format(parseFloat(project.commission_vat_rate.percentage ?? 0).toFixed(2))}}%</label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-span-2">
                                                    <label for="commission_total"
                                                           class="block text-sm text-gray-900">
                                                        Total
                                                    </label>
                                                    <div class="mt-1">
                                                        <input disabled type="text" id="commission_total"
                                                               v-model="form.commission_total"
                                                               class="bg-gray-100 cursor-not-allowed block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.commission_total}"
                                                        />
                                                    </div>
                                                </div>


                                                <div class="col-span-1">
                                                </div>


                                            </div>

                                        </div>
                                    </div>

                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                            class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-amaze-coral hover:bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span v-if="updating === true">Update</span>
                                        <span v-else>Save</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, watch} from 'vue'
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxLabel,
    ComboboxOption,
    ComboboxOptions,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot
} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {
    CheckIcon,
    ExclamationCircleIcon,
    LinkIcon,
    PlusSmIcon,
    QuestionMarkCircleIcon,
    SelectorIcon,
    RefreshIcon,
    InformationCircleIcon
} from '@heroicons/vue/solid'
import {useForm, Link} from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors.vue";
import {mapState} from "vuex";
import {emitter} from "@/eventHub";
import Popper from "vue3-popper";
import Editor from "@/Components/Editor.vue";
import moment from "moment";
import Audit from "@/Components/Modal/Audit.vue";

export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        QuestionMarkCircleIcon,
        ExclamationCircleIcon,
        XIcon,
        Combobox,
        ComboboxButton,
        ComboboxInput,
        ComboboxLabel,
        ComboboxOption,
        ComboboxOptions,
        CheckIcon,
        SelectorIcon,
        Link,
        RefreshIcon,
        Popper,
        InformationCircleIcon,
        Editor,
        Audit
    },
    props: {
        quote: Object,
        project: Object
    },
    setup() {
        const openModal = ref(false);

        return {openModal};
    },
    data() {
        return {
            moment: moment,
            show: ref(false),
            activity_logs: ref([]),
            showErrors: ref(false),
            updating: ref(false),
            loadingService: ref(false),
            regions: [],
            query: '',
            service: [],
            selectedSupplier: ref(""),
            vat_rates: [],
            showSellInputs: true,
            form: useForm({
                id: null,
                quote_id: null,
                folder_id: null,
                name: null,
                starts_at: null,
                ends_at: null,
                country_id: "",
                service_type_id: "",
                organisation_id: ref(),
                description: "",
                financial_notes: "",
                buy_price: 0.00,
                buy_costing_type: this.buy_costing_type ? this.buy_costing_type : this.project.calculation_method,
                buy_unit: 0,
                buy_no: 0,
                buy_gross_total: this.buy_gross_total ?? 0,
                buy_net_total: this.buy_net_total ?? 0,
                buy_vat_percentage: "",
                buy_currency_id: null,
                sell_currency_id: null,
                sell_price: 0.00,
                sell_costing_type: this.sell_costing_type ? this.sell_costing_type : this.project.calculation_method,
                sell_unit: 0,
                sell_no: 0,
                sell_net_total: 0.00,
                sell_gross_total: 0.00,
                sell_vat_percentage: "",
                commission_type: "",
                commission_costing_type: "",
                commission_amount: 0.00,
                is_including_commission_vat: 0,
                commission_total: 0.00,
            })
        }
    },
    computed: {
        ...mapState({
            suppliers: state => state.services.suppliers ?? null,
            countries: state => state.services.countries ?? null,
            costing_types: state => state.services.costing_types ?? null,
            service_types: state => state.services.service_types ?? null,
            amount_types: state => state.services.amount_types ?? null,
                editor() {
                    return this.$refs.description;
                },
            financialeditor() {
                return this.$refs.financial_notes;
            }
        }),
        filteredSuppliers: function () {
            return this.query === '' && this.query.length > 2
                ? this.suppliers
                : this.suppliers.filter((supplier) => {
                    return supplier.name.toLowerCase().includes(this.query.toLowerCase()) &&
                        (this.form.country_id !== "" && ("service" in supplier) && supplier.service !== null ? supplier.service.address.country_id === this.form.country_id
                            : true) &&
                        (this.form.service_type_id !== "" && ("service" in supplier) && supplier.service !== null ? supplier.service.service_type_id === this.form.service_type_id
                            : true)
                })
        },
        serviceData() {
            const sell_price = this.form.sell_price;
            const sell_no = this.form.sell_no;
            const sell_unit = this.form.sell_unit;
            const sell_vat_percentage = this.form.sell_vat_percentage;
            const sell_costing_type = this.form.sell_costing_type;
            const buy_price = this.form.buy_price;
            const buy_no = this.form.buy_no;
            const buy_unit = this.form.buy_unit;
            const buy_gross_total = this.form.buy_gross_total
            const buy_net_total = this.form.buy_net_total
            const buy_vat_percentage = this.form.buy_vat_percentage;
            const buy_costing_type = this.form.buy_costing_type;

            return {
                sell_price,
                sell_no,
                sell_unit,
                sell_vat_percentage,
                sell_costing_type,
                buy_price,
                buy_no,
                buy_unit,
                buy_vat_percentage,
                buy_costing_type,
                buy_net_total,
                buy_gross_total
            }
        },
        commissionData() {

            const commission_type = this.form.commission_type;
            const commission_costing_type = this.form.commission_costing_type;
            const is_including_commission_vat = this.form.is_including_commission_vat;
            const commission_amount = this.form.commission_amount;
            const sell_price = this.form.sell_price;
            const sell_no = this.form.sell_no;
            const sell_unit = this.form.sell_unit;
            const sell_vat_percentage = this.form.sell_vat_percentage;
            const sell_costing_type = this.form.sell_costing_type;
            const buy_price = this.form.buy_price;
            const buy_no = this.form.buy_no;
            const buy_unit = this.form.buy_unit;
            const buy_gross_total = this.form.buy_gross_total
            const buy_net_total = this.form.buy_net_total
            const buy_vat_percentage = this.form.buy_vat_percentage;
            const buy_costing_type = this.form.buy_costing_type;

            return {
                commission_type,
                commission_costing_type,
                is_including_commission_vat,
                commission_amount,
                sell_price,
                sell_no,
                sell_unit,
                sell_vat_percentage,
                sell_costing_type,
                buy_price,
                buy_no,
                buy_unit,
                buy_vat_percentage,
                buy_costing_type,
                buy_net_total,
                buy_gross_total
            }
        }
    },
    methods: {
        refreshSuppliers() {
            this.$store.dispatch('services/getAll', {'project_id': this.project.id, 'quote_id': this.quote.id});
        },
        toggleSellInformation() {
            this.showSellInputs = !this.showSellInputs;
        },
        submit() {
            this.form.buy_price = typeof this.form.buy_price === 'string' ? this.form.buy_price.replace(',','.') : 0;
            this.form.sell_price = typeof this.form.sell_price === 'string' ? this.form.sell_price.replace(',','.') : 0;
            if(this.form.commission_amount !== "" && this.form.commission_amount !== null) {
                this.form.commission_amount = this.parseLocaleNumber(this.form.commission_amount);
                this.form.commission_total = this.parseLocaleNumber(this.form.commission_total);
            }
            if (this.updating === true) {
                this.form.post(route('frontend.project.quote.service.update', [this.project.id, this.quote.id,
                    this.form.id]), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                        this.close();
                    },
                    onError: errors => {
                        this.showErrors = true;
                        this.form.buy_price = this.formatCurrency(this.form.buy_price, this.project.bank_account.currency.code)
                        this.form.sell_price = this.formatCurrency(this.form.sell_price, this.project.bank_account.currency.code)
                        this.form.commission_amount = this.formatCurrency(this.form.commission_amount, this.project.bank_account.currency.code)
                        this.form.commission_total = this.formatCurrency(this.form.commission_total, this.project.bank_account.currency.code)
                    },
                    preserveScroll: true,
                });
            } else {
                this.form.post(route('frontend.project.quote.service.create', [this.project.id, this.quote.id]), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                        this.close();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    },
                    preserveScroll: true,
                });
            }
        },

        close() {
            this.form.reset();
            this.form.clearErrors();
            this.selectedSupplier = "";
            this.showErrors = false;
            this.show = false;
        },

        open() {
            this.form.clearErrors();
            this.show = true;
        },
        number_format(nStr) {
            nStr += '';
            let x = nStr.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        doRounding(value, decimals) {
            return Number(Math.round(value + "e" + decimals) + "e-" + decimals).toFixed(2);
        },
        parseLocaleNumber(value) {
            return String(value ?? 0).replace(',', '.').replace(/\.(?=.*\.)/, '').replace(/[^0-9\.\-]/, '');
        }
    },
    watch: {
        show: function (value) {
            if (value === true) {
                this.$store.dispatch('services/getAll', {
                    project_id: this.project.id,
                    quote_id: this.quote.id
                });
                this.vat_rates = this.project.office.address.country.vat_rates ?? [];
            }
        },
        'form.country_id': {
            deep: false,
            handler(id) {
                if (id === "" || (this.countries.find(country => country.id === id) === "undefined" && typeof this.countries.find(country => country.id === id).regions === "undefined")) {
                    this.regions = [];
                } else if (typeof this.countries.find(country => country.id === id) !== 'undefined') {
                    this.regions = this.countries.find(country => country.id === id).regions
                }

            }
        },

        'form.buy_costing_type': {
            deep: false,
            handler(id) {
                    if(this.updating === false) {
                    this.form.sell_costing_type = this.form.buy_costing_type
                    }
            }
        },
        'form.buy_unit': {
            deep: false,
            handler(id) {
                if(this.updating === false) {
                    this.form.sell_unit = this.form.buy_unit
                }
            }
        },
        'form.commission_type' : {
            deep: false,
            handler(value) {
                if(value === 'Fixed') {
                    // Set the commission costing type to null.
                    this.form.commission_costing_type = "";
                } else if((value === '' || value === null) && this.loadingService === false) {
                    // Reset all commission fields when type is cleared by the user.
                    this.form.commission_costing_type = "";
                    this.form.commission_amount = 0.00;
                    this.form.commission_total = 0.00;
                }
            }
        },
        'form.buy_vat_percentage': {
            deep: false,
            handler(id) {
                if(this.updating === false) {
                    this.form.sell_vat_percentage = this.form.buy_vat_percentage
                }
            }
        },
        'form.buy_no': {
            deep: false,
            handler(id) {
                if(this.updating === false) {
                    this.form.sell_no = this.form.buy_no
                }
            }
        },
        selectedSupplier: {
            deep: true,
            handler(supplier) {
                if(supplier && supplier.id) {
                    this.form.organisation_id = supplier.id;
                }
            }
        },
        commissionData: {
            deep: true,
            handler(val) {

                // Commission Calculations
                if (val.commission_amount !== null && val.commission_amount !== "") {
                    val.commission_amount = this.parseLocaleNumber(val.commission_amount);
                    val.buy_net_total = this.parseLocaleNumber(this.form.buy_net_total);
                    val.buy_gross_total = this.parseLocaleNumber(this.form.buy_gross_total);
                    val.sell_net_total = this.parseLocaleNumber(this.form.sell_net_total);
                    val.sell_gross_total = this.parseLocaleNumber(this.form.sell_gross_total);

                    if(val.commission_type === 'Fixed') {
                        if(this.form.is_including_commission_vat == true) {
                            this.form.commission_total = parseFloat(val.commission_amount);
                        } else {
                            this.form.commission_total = parseFloat(val.commission_amount) + parseFloat((+(this.service !== null && this.service.commission_vat_rate !== null &&  this.service.hasOwnProperty('commission_vat_rate') === true ? this.service.commission_vat_rate.percentage :  this.project.commission_vat_rate.percentage) / 100) *
                                +val.commission_amount);
                        }
                    } else {
                        if (val.commission_costing_type === 'Gross') {
                            if( this.form.is_including_commission_vat == true ) {
                                this.form.commission_total = (parseFloat(+val.buy_gross_total / 100) *
                                    parseFloat(+val.commission_amount));

                            } else {
                                this.form.commission_total = (parseFloat(+val.buy_gross_total / 100) *
                                    parseFloat(+val.commission_amount)) + ((+(this.service !== null && this.service.commission_vat_rate !== null && this.service.hasOwnProperty('commission_vat_rate') === true  ? this.service.commission_vat_rate.percentage :  this.project.commission_vat_rate.percentage) / 100) *
                                    (parseFloat(+val.buy_gross_total) / 100) *
                                    parseFloat(+val.commission_amount));
                            }
                        } else {
                            if(this.form.is_including_commission_vat == true) {
                                this.form.commission_total = parseFloat(+val.buy_net_total / 100) *
                                    parseFloat(+val.commission_amount);

                            } else {
                                this.form.commission_total = (parseFloat(+val.buy_net_total / 100) *
                                    parseFloat(+val.commission_amount)) + ((+(this.service !== null && this.service.commission_vat_rate !== null && this.service.hasOwnProperty('commission_vat_rate') === true  ? this.service.commission_vat_rate.percentage :  this.project.commission_vat_rate.percentage) / 100) *
                                    (parseFloat(+val.buy_net_total) / 100) *
                                    parseFloat(+val.commission_amount));
                            }
                        }
                    }
                    this.form.commission_total = this.formatCurrency(this.form.commission_total, this.project.bank_account.currency.code)
                }
            }
        },
        serviceData: {
            deep: true,
            handler(val) {
                let vat_rate;

                let buy_net_total = 0;
                let buy_gross_total = 0;

                if(val.buy_price === "") {
                    val.buy_price = 0;
                }

                if(val.sell_price === "") {
                    val.sell_price = 0;
                }

                val.buy_price = String(val.buy_price ?? 0).replace(',', '.').replace(/\.(?=.*\.)/, '').replace(/[^0-9\.\-]/, '')
                val.sell_price = String(val.sell_price ?? 0).replace(',', '.').replace(/\.(?=.*\.)/, '').replace(/[^0-9\.\-]/, '');
                val.commission_amount = String(val.commission_amount ?? 0).replace(',', '.').replace(/\.(?=.*\.)/, '').replace(/[^0-9\.\-]/, '');

                // Buy Calculations
                if (val.buy_vat_percentage !== "" && val.buy_costing_type !== "" && val.buy_vat_percentage !== null
                    && val.buy_costing_type !== null) {
                    if (val.buy_vat_percentage !== "") {

                        vat_rate = this.vat_rates.find(vat_rate => vat_rate.percentage === val.buy_vat_percentage);
                    }
                    if(vat_rate == null) {
                        vat_rate = {
                            percentage: 0
                        };
                    }

                    if (val.buy_costing_type === 'Gross') {
                        buy_gross_total = parseFloat(val.buy_price ?? 0).toFixed(2) *
                            parseInt(val.buy_unit ?? 0) *
                            parseInt(val.buy_no ?? 0);

                        buy_net_total = parseFloat(val.buy_price ?? 0).toFixed(2) / (1 +
                                (vat_rate.percentage / 100) ?? 0.1) *
                            parseInt(val.buy_unit) * parseInt(val.buy_no);
                        this.form.buy_gross_total = this.formatCurrency(buy_gross_total, this.project.bank_account.currency.code);
                        this.form.buy_net_total = this.formatCurrency(buy_net_total, this.project.bank_account.currency.code);
                    } else {

                        buy_gross_total = parseFloat(val.buy_price ?? 0).toFixed(2) * (1 + (vat_rate.percentage /
                                100)) *
                            parseInt(val.buy_unit) * parseInt(val.buy_no);

                        buy_net_total = parseFloat(val.buy_price ?? 0).toFixed() * parseInt(val.buy_unit) *
                            parseInt(val.buy_no);

                        this.form.buy_gross_total = this.formatCurrency(buy_gross_total, this.project.bank_account.currency.code);
                        this.form.buy_net_total = this.formatCurrency(buy_net_total, this.project.bank_account.currency.code);
                    }

                } else {
                    this.form.buy_gross_total = this.formatCurrency(0, this.project.bank_account.currency.code);
                    this.form.buy_net_total = this.formatCurrency(0, this.project.bank_account.currency.code);
                }

                // Sell Calculations
                if (val.sell_vat_percentage !== "" && val.sell_costing_type !== "" && val.sell_vat_percentage
                    !== null
                    && val.sell_costing_type !== null) {


                    if (val.sell_vat_percentage !== "") {
                        vat_rate = this.vat_rates.find(vat_rate => vat_rate.percentage === val.sell_vat_percentage);
                    }

                    if(vat_rate == null) {
                        vat_rate = {
                            percentage: 0
                        };
                    }

                    if (val.sell_costing_type === 'Gross') {

                        let sell_gross_total = parseFloat(val.sell_price ?? 0) * parseInt(val.sell_unit) *
                            parseInt(val.sell_no)

                        let sell_net_total = parseFloat(val.sell_price ?? 0) / (1 +
                                (vat_rate.percentage / 100)) *
                            parseInt(val.sell_unit) * parseInt(val.sell_no);

                        this.form.sell_gross_total = this.formatCurrency(sell_gross_total, this.project.bank_account.currency.code);
                        this.form.sell_net_total = this.formatCurrency(sell_net_total, this.project.bank_account.currency.code);
                    } else {

                        let sell_gross_total = parseFloat(val.sell_price ?? 0) * (1 + (vat_rate.percentage /
                                100)) *
                            parseInt(val.sell_unit) * parseInt(val.sell_no);

                        let sell_net_total = parseFloat(val.sell_price ?? 0) * parseInt(val.sell_unit) *
                            parseInt(val.sell_no);

                        this.form.sell_gross_total = this.formatCurrency(sell_gross_total, this.project.bank_account.currency.code);
                        this.form.sell_net_total = this.formatCurrency(sell_net_total, this.project.bank_account.currency.code);
                    }

                } else {
                    this.form.sell_gross_total = this.formatCurrency(0, this.project.bank_account.currency.code);
                    this.form.sell_net_total = this.formatCurrency(0, this.project.bank_account.currency.code);
                }

            }
        }
    },
    mounted() {
        // Create a new service, opens the create service slideout.
        emitter.on('createServiceSlideout', (folder_id) => {
            this.updating = false;
            this.service = null;
            this.form.quote_id = this.quote.id;
            this.form.folder_id = folder_id;
            this.form.country_id = this.project.country_id;
            this.form.starts_at = moment(this.project.starts_at).format('YYYY-MM-DD')
            this.form.ends_at = moment(this.project.ends_at).format('YYYY-MM-DD')
            this.form.organisation_id = null;
            this.selectedSupplier = "";
            this.form.buy_currency_id = this.project.bank_account.currency_id;
            this.form.sell_currency_id = this.project.bank_account.currency_id;
            this.open();
        });

        // Edit an existing service, opens the create service slideout and populates the form.
        emitter.on("openServiceSlideout", (service) => {
            this.service = service;
            this.updating = true;
            this.activity_logs = service.activity_logs;
            this.loadingService = true;
            this.form.id = service.id;
            this.form.quote_id = service.quote_id;
            this.form.folder_id = service.folder_id;
            this.form.name = service.name;
            this.form.organisation_id = service.organisation_id;
            this.selectedSupplier = service.supplier ?? ""
            this.form.buy_price = this.formatCurrency(service.buy_price, this.project.bank_account.currency.code);
            this.form.buy_unit = service.buy_unit;
            this.form.buy_no = service.buy_no;
            this.form.buy_costing_type = service.buy_costing_type;
            this.form.buy_vat_percentage = service.buy_vat_percentage;
            this.form.sell_price = this.formatCurrency(service.sell_price, this.project.bank_account.currency.code);
            this.form.sell_unit = service.sell_unit;
            this.form.sell_no = service.sell_no;
            this.form.sell_costing_type = service.sell_costing_type;
            this.form.sell_vat_percentage = service.sell_vat_percentage;
            this.form.commission_type = service.commission_type ?? "";
            this.form.commission_costing_type = service.commission_costing_type ?? "";
            this.form.commission_amount = this.formatCurrency(service.commission_amount, this.project.bank_account.currency.code);
            this.form.is_including_commission_vat = service.is_including_commission_vat ?? false;
            this.form.country_id = service.country_id;
            this.form.starts_at = service.starts_at;
            this.form.ends_at = service.ends_at;
            this.form.service_type_id = service.service_type_id;
            if (this.form.buy_costing_type === this.form.sell_costing_type
                && this.form.buy_no === this.form.sell_no
                && this.form.buy_unit === this.form.sell_unit
                && this.form.buy_vat_percentage === this.form.sell_vat_percentage) {
                this.showSellInputs = false;
            } else {
                this.showSellInputs = true;
            }
            this.form.description = service.description;
            this.form.financial_notes = service.financial_notes;
            this.form.buy_currency_id = this.project.bank_account.currency_id;
            this.form.sell_currency_id = this.project.bank_account.currency_id
            this.form.commission_amount = service.commission_amount
            this.form.commission_total = service.commission_total
            this.loadingService = false;
            this.open();
        });


    }
}
</script>
